export default __webpack_public_path__ + "static/media/UConn-RobustRL-2024.09d5ea66.pdf";